import {fetchHandler,fetchCatcher,getLocalStorage} from '@/js/sageflo/ui-helpers.js'
//Don't put users for admin purposes in this file
export default {
  namespaced: false,
  state: {
      loading: true,
      activeView: 'search',
      navbarCollapsed: true,
      detailView: null,
      activeSubAccount: null,
      viewType: getLocalStorage('viewMode','list',false,['list','journey']),
  },
  getters: {},
  actions: {
  },
  mutations: {
    setViewType(state,viewType){
      state.viewType = viewType;
    },
    setDetailView(state,name){
      state.detailView = name;
    },
    setActiveView(state,name){
      state.activeView = name;
    },
    setNavbarCollapse(state,collapsed){
      state.navbarCollapsed = collapsed;
    },
    toggleNavbarCollapse(state){
      state.navbarCollapsed = !state.navbarCollapsed;
    },
    setActiveSubAccount(state,subAccount){
      state.activeSubAccount = subAccount;
    },
    setLoading(state,loading){
      state.loading = loading;
    }

  },  
}